import { Routes } from '@angular/router';
import { CustomTodayComponent } from './custom-today/custom-today.component';
import { AuthGuard } from '@app/guards/auth.guard';
import { Constants } from '@app/common/constants';
import { DEFAULT_MODAL_ROUTE_CONFIG } from '@app/common/default-modal-route-config';
import { DefaultRoutes } from '@app/common/default-routes';

export const IMGROUP_CUSTOM_ROUTE_CONFIG: Routes = [
  {
    path: '', component: CustomTodayComponent, pathMatch: 'full', canActivate: [AuthGuard], data: Constants.TODAY_DEFAULT_DATA
  },
  DefaultRoutes.YOUR_BOARD,
  DefaultRoutes.COLLABORATION,
  DefaultRoutes.FIND_INFO,
  DefaultRoutes.APPS_TOOLS,
  DefaultRoutes.SETTINGS,
  DefaultRoutes.CREATE_SITE,
  DefaultRoutes.EDITOR_DASHBOARD,
  DefaultRoutes.FIRST_DAY,
  DefaultRoutes.ADMIN,
  DefaultRoutes.ABOUT,
  DefaultRoutes.PEOPLE,
  DefaultRoutes.BROADCAST_MESSAGES,
  DefaultRoutes.RESTAURANT,
  DefaultRoutes.KPI_CHARTS,
  DefaultRoutes.INFOBOXES,
  DefaultRoutes.POWER_BI,
  DefaultRoutes.PAGES,
  {
    path: '**', redirectTo: ''
  },
  ...DEFAULT_MODAL_ROUTE_CONFIG
];
